module.exports = __webpack_public_path__ + "static/media/rocket.17249a86.svg";